import { OnboardingProfessionScreen } from "@/components/screens/onboarding/ProfessionScreen"
import { useNavigate } from "@/router"
import { professionDraftAtom } from "@/state/draft/profession"
import { useAnalytics } from "@/hooks/use-analytics"
import { useAtom } from "jotai"
import { useEffect } from "react"

export default function ProfessionPage() {
	const { sendEvent } = useAnalytics("Create_Profession")
	
	useEffect(() => {
		sendEvent("Step_Profession__View")
	}, [])
	const [profession, setProfession] = useAtom(professionDraftAtom)
	const navigate = useNavigate()

	return (
		<OnboardingProfessionScreen
			profession={profession}
			onSubmit={(data) => {
				setProfession(data)
				sendEvent("Step_Profession__Continue")
				navigate("/report/create/address")
			}}
			onBack={() => {
				navigate("/report/create/period")
			}}
		/>
	)
}
